import { API_URL } from '../config/apiConfig';

const getAuthHeaders = () => {
    const token = localStorage.getItem('token');
    if (!token) {
        throw new Error('No authentication token found');
    }
    return {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
    };
};

export const getAllCustomers = async () => {
    try {
        const response = await fetch(`${API_URL}/api/customers`, {
            method: 'GET',
            headers: getAuthHeaders(),
        });
        
        if (!response.ok) {
            const errorData = await response.json().catch(() => null);
            throw new Error(errorData?.error || 'Failed to fetch customers');
        }
        
        return response.json();
    } catch (error) {
        console.error('Error in getAllCustomers:', error);
        throw error;
    }
};

export const getCustomer = async (id) => {
    try {
        const response = await fetch(`${API_URL}/api/customers/${id}`, {
            method: 'GET',
            headers: getAuthHeaders(),
        });
        
        if (!response.ok) {
            const errorData = await response.json().catch(() => null);
            throw new Error(errorData?.error || 'Failed to fetch customer');
        }
        
        return response.json();
    } catch (error) {
        console.error('Error in getCustomer:', error);
        throw error;
    }
};

export const createCustomer = async (customerData) => {
    try {
        const response = await fetch(`${API_URL}/api/customers`, {
            method: 'POST',
            headers: getAuthHeaders(),
            body: JSON.stringify(customerData),
        });
        
        if (!response.ok) {
            const errorData = await response.json().catch(() => null);
            throw new Error(errorData?.error || 'Failed to create customer');
        }
        
        return response.json();
    } catch (error) {
        console.error('Error in createCustomer:', error);
        throw error;
    }
};

export const updateCustomer = async (id, customerData) => {
    try {
        const response = await fetch(`${API_URL}/api/customers/${id}`, {
            method: 'PATCH',
            headers: getAuthHeaders(),
            body: JSON.stringify(customerData),
        });
        
        if (!response.ok) {
            const errorData = await response.json().catch(() => null);
            throw new Error(errorData?.error || 'Failed to update customer');
        }
        
        return response.json();
    } catch (error) {
        console.error('Error in updateCustomer:', error);
        throw error;
    }
};

export const deleteCustomer = async (id) => {
    try {
        const response = await fetch(`${API_URL}/api/customers/${id}`, {
            method: 'DELETE',
            headers: getAuthHeaders(),
        });
        
        if (!response.ok) {
            const errorData = await response.json().catch(() => null);
            throw new Error(errorData?.error || 'Failed to delete customer');
        }
        
        return response.json();
    } catch (error) {
        console.error('Error in deleteCustomer:', error);
        throw error;
    }
};

export const addTeamToCustomer = async (customerId, teamId) => {
    try {
        const response = await fetch(`${API_URL}/api/customers/${customerId}/teams`, {
            method: 'POST',
            headers: getAuthHeaders(),
            body: JSON.stringify({ teamId }),
        });
        
        if (!response.ok) {
            const errorData = await response.json().catch(() => null);
            throw new Error(errorData?.error || 'Failed to add team to customer');
        }
        
        return response.json();
    } catch (error) {
        console.error('Error in addTeamToCustomer:', error);
        throw error;
    }
};

export const removeTeamFromCustomer = async (customerId, teamId) => {
    try {
        const response = await fetch(`${API_URL}/api/customers/${customerId}/teams/${teamId}`, {
            method: 'DELETE',
            headers: getAuthHeaders(),
        });
        
        if (!response.ok) {
            const errorData = await response.json().catch(() => null);
            throw new Error(errorData?.error || 'Failed to remove team from customer');
        }
        
        return response.json();
    } catch (error) {
        console.error('Error in removeTeamFromCustomer:', error);
        throw error;
    }
};
